// @flow
import { isEqual } from "lodash";
import { defaultMemoize, createSelectorCreator } from "reselect";

const createDeepEqualSelector = createSelectorCreator(
	defaultMemoize,
	isEqual,
);

export {
	createDeepEqualSelector,
};
